import React from 'react';
import { connect } from 'react-redux';
import { ThemeProvider } from 'emotion-theming';
import { Switch, Route, withRouter } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import Header from './components/Header.js';
import Login from './pages/login/Login.js';
import Locations from './pages/locations/Locations.js';
import ErrorNotification from './components/ErrorNotification.js';
import { routes } from './routes.js';
import i18next from './locales';

class App extends React.Component {
  state = {
    routeDepth: 0,
    slideDirection: 'next',
    isBackVisible: false,
    language: 'en',
  };

  componentDidMount() {
    i18next.on('languageChanged', lng => {
      this.setState({ language: lng });
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const url = nextProps.location.pathname;
    if (url === prevState.url) return null;

    if (
      prevState &&
      prevState.url &&
      prevState.url.indexOf('/clientSelection') > -1
    ) {
      return { slideDirection: 'none' };
    }

    const oldUrlDepth = prevState.routeDepth;
    let newUrlDepth = 0;

    if (url.indexOf('/services/', 0) > -1) {
      newUrlDepth = 100 + parseInt(url.replace('/services/', ''), 10);
    } else {
      const route = routes.filter(r => r.path === url)[0];
      if (route) {
        newUrlDepth = route.depth;
      }
    }

    return {
      routeDepth: newUrlDepth,
      slideDirection: newUrlDepth >= oldUrlDepth ? 'next' : 'prev',
      isBackVisible: newUrlDepth > 0 && url !== '/confirmation',
    };
  }

  componentDidUpdate() {
    const url = this.props.location.pathname;
    if (url !== this.state.url) {
      this.setState({ url });
    }
  }

  getTheme() {
    const { businessInfo } = this.props;
    if (!businessInfo) return {};

    const kioskConfig = businessInfo.company.kiosk_config;
    const theme = {
      backgroundUrl: kioskConfig.background,
      headerColor: kioskConfig.header_color
        ? kioskConfig.header_color
        : '#ffffff',
      logoUrl: kioskConfig.logo,
      primaryFontColor: kioskConfig.primary_font_color,
      secondaryFontColor: kioskConfig.secondary_font_color,
      themeColor: kioskConfig.theme_color,
      backButtonColor:
        kioskConfig.primary_font_color === kioskConfig.header_color ||
        !kioskConfig.header_color
          ? kioskConfig.theme_color
          : kioskConfig.primary_font_color,
    };

    return theme;
  }

  render() {
    const theme = this.getTheme();
    const isContentShown = this.props.appLocation && this.props.businessInfo;

    return (
      <div>
        <ErrorNotification />
        <ThemeProvider theme={theme}>
          {isContentShown && (
            <Header isBackVisible={this.state.isBackVisible} />
          )}

          {!this.props.authToken && <Login />}

          {!this.props.appLocation && this.props.locations && <Locations />}
          {isContentShown && (
            <Route
              path="/"
              render={({ location }) => (
                <TransitionGroup
                  childFactory={child =>
                    React.cloneElement(child, {
                      classNames: this.state.slideDirection,
                    })
                  }
                >
                  <CSSTransition
                    component="div"
                    classNames={this.state.slideDirection}
                    key={location.key}
                    timeout={{ enter: 300, exit: 300 }}
                  >
                    <div className="transition-container" key={location.key}>
                      <Switch location={location}>
                        {routes.map(r => (
                          <Route
                            key={r.path}
                            exact={r.exact}
                            path={r.path}
                            component={r.component}
                            render={r.render}
                          />
                        ))}
                      </Switch>
                    </div>
                  </CSSTransition>
                </TransitionGroup>
              )}
            />
          )}
        </ThemeProvider>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    authToken: state.app.authToken,
    locations: state.app.locations,
    appLocation: state.app.location,
    businessInfo: state.app.businessInfo,
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {},
    null,
    { pure: false }
  )(App)
);
